var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9206 10.2548L10.8257 8.20852C9.52752 7.55981 8 8.50326 8 9.95387V14.0461C8 15.4967 9.52752 16.4402 10.8257 15.7915L14.9206 13.7452C16.3598 13.0262 16.3598 10.9737 14.9206 10.2548Z",
    fill: "#55217E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39535 12C3.39535 7.24779 7.24779 3.39535 12 3.39535C16.7522 3.39535 20.6047 7.24779 20.6047 12C20.6047 12.6581 20.5309 13.2983 20.3914 13.9128C20.3061 14.2886 20.5417 14.6623 20.9174 14.7475C21.2932 14.8328 21.667 14.5973 21.7522 14.2216C21.9145 13.5064 22 12.7628 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22C12.7628 22 13.5064 21.9145 14.2216 21.7522C14.5973 21.667 14.8328 21.2932 14.7475 20.9174C14.6623 20.5417 14.2886 20.3061 13.9128 20.3914C13.2983 20.5309 12.6581 20.6047 12 20.6047C7.24779 20.6047 3.39535 16.7522 3.39535 12ZM18.5116 15.0233C18.8969 15.0233 19.2093 15.3356 19.2093 15.7209V17.814H21.3023C21.6876 17.814 22 18.1263 22 18.5116C22 18.8969 21.6876 19.2093 21.3023 19.2093H19.2093V21.3023C19.2093 21.6876 18.8969 22 18.5116 22C18.1263 22 17.814 21.6876 17.814 21.3023V19.2093H15.7209C15.3356 19.2093 15.0233 18.8969 15.0233 18.5116C15.0233 18.1263 15.3356 17.814 15.7209 17.814H17.814V15.7209C17.814 15.3356 18.1263 15.0233 18.5116 15.0233Z",
    fill: "#55217E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVideo);
export default __webpack_public_path__ + "static/media/addVideo.05a846fa.svg";
export { ForwardRef as ReactComponent };